import * as Sentry from '@sentry/react';
import {
  createErrorReporting,
  type IErrorReportingClient,
} from '@lqa-frontend/shared';

const sentryClient: IErrorReportingClient = {
  init: (options) =>
    Sentry.init({
      dsn: options.dsn,
      environment: options.environment,
      // SDK v11 replaced `sendDefaultPii` with `dataCollection`, whose defaults
      // collect user info, cookies, headers and query params. Map the flag.
      dataCollection: {
        userInfo: options.sendDefaultPii,
        cookies: options.sendDefaultPii,
        httpHeaders: options.sendDefaultPii,
        urlQueryParams: options.sendDefaultPii,
        httpBodies: [],
        // The login handler closes over the password; keep it out of stack frames.
        stackFrameVariables: false,
      },
      beforeBreadcrumb: (breadcrumb) =>
        options.beforeBreadcrumb(breadcrumb) === null ? null : breadcrumb,
      beforeSendLog: (log) => ({ ...log, ...options.beforeSendLog(log) }),
    }),
  logger: {
    warn: (message, attributes) => Sentry.logger.warn(message, attributes),
    info: (message, attributes) => Sentry.logger.info(message, attributes),
  },
  captureMessage: (message, captureContext) => {
    Sentry.captureMessage(message, captureContext);
  },
};

const errorReporting = createErrorReporting(sentryClient);

export const initErrorReporting = (): void =>
  errorReporting.init({
    dsn: Env.SENTRY_DSN ?? '',
    environment: Env.NODE_ENV,
    sensitivePaths: ['/auth/login', '/auth/forgot'],
  });

export const reportRequestFailure = errorReporting.reportRequestFailure;
export const reportAction = errorReporting.reportAction;
